import amex from './amex.png'
import styles from './CreditCard.module.scss'
import diners from './diners.png'
import discover from './discover.png'
import jcb from './jcb.png'
import mastercard from './mastercard.png'
import unionpay from './unionpay.png'
import visa from './visa.png'

const cardLogos = {
  visa,
  mastercard,
  amex,
  diners,
  discover,
  jcb,
  unionpay
}

const CreditCard = ({ uiPan, expDate = 'MM/YY', network, holder, last4 }) => (
  <div className={styles.card}>
    <div className={styles.chipRow}></div>
    <div className={styles.cardNoRow}>
      <div className={styles.cardNo}>
        {last4 ? (
          <>
            {' '}
            <span>•••• •••• •••• </span>
            {last4}
          </>
        ) : (
          <>{uiPan || <span>•••• •••• •••• ••••</span>}</>
        )}
      </div>
    </div>
    <div className={styles.expDateRow}>
      <div className={styles.validThru}>valid thru</div>
      <div className={styles.expDate}>
        {expDate ? expDate.replace(/\s/g, '') : 'MM/YY'}
      </div>
    </div>
    <div className={styles.cardholderNameRow}>
      <div className={styles.cardHolderName}>{holder || 'Cardholder Name'}</div>
    </div>
    <div className={styles.cardLogo}>
      {network && <img src={cardLogos[network]} alt={network} />}
    </div>
  </div>
)

export default CreditCard
